function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getFixedCellSize } from './FormLineItems.types';
var cellAttributesBySize = {
  xs: {
    minWidth: '36px',
    flexShrink: 0,
    flexBasis: 0
  },
  s: {
    minWidth: '80px',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0
  },
  m: {
    minWidth: '160px',
    flexGrow: 2,
    flexShrink: 0,
    flexBasis: 0
  },
  l: {
    minWidth: '240px',
    flexGrow: 3,
    flexShrink: 0,
    flexBasis: 0
  },
  xl: {
    minWidth: '320px',
    flexGrow: 4,
    flexShrink: 0,
    flexBasis: 0
  },
  xxl: {
    minWidth: '400px',
    flexGrow: 5,
    flexShrink: 0,
    flexBasis: 0
  }
};
export var formLineItemsTheme = {
  baseStyle: _ref => {
    var {
      size,
      hasOverflowX
    } = _ref;
    return {
      container: _objectSpread({
        width: '100%',
        height: '100%',
        isolation: 'isolate',
        overflowX: 'auto',
        overflowY: 'hidden',
        position: 'relative',
        borderTopRadius: 'l'
      }, hasOverflowX && {
        '[data-is-sticky="true"]': {
          '&[data-component="FormLineItems.HeaderCell"]': {
            borderLeft: 'basic.light',
            position: 'sticky',
            right: 0,
            top: 0
          },
          '&[data-component="FormLineItems.Cell"]': {
            zIndex: 'sticky',
            borderLeft: 'basic.light',
            position: 'sticky',
            top: 0,
            right: 0,
            boxShadow: 400,
            '[data-is-sticky="true"]': {
              marginLeft: 's'
            }
          }
        }
      }),
      headerRow: {
        display: 'flex',
        minHeight: '48px'
      },
      headerCell: _objectSpread(_objectSpread({
        boxSizing: 'content-box',
        backgroundColor: 'neutral.lightest',
        borderBottom: 'basic.lighter'
      }, getFixedCellSize(size)), {}, {
        height: '48px'
      }),
      // We need a cell content layer cause flex doesn't play well with padding
      headerCellContent: {
        overflowX: 'hidden',
        margin: 's'
      },
      body: {
        position: 'relative',
        backgroundColor: 'neutral.white',
        flexGrow: 1,
        '&[data-loading="true"]': {
          minHeight: '96px'
        }
      },
      row: {
        position: 'relative',
        display: 'flex',
        ':first-of-type': {
          '> div': {
            paddingTop: 'm'
          }
        }
      },
      cell: _objectSpread({
        boxSizing: 'content-box',
        backgroundColor: 'neutral.white',
        height: '72px',
        overflow: 'hidden'
      }, getFixedCellSize(size)),
      // We need a cell content layer cause flex doesn't play well with padding
      cellContent: {
        height: '100%',
        marginX: 'xs',
        marginY: 'xxs'
      }
    };
  },
  sizes: {
    xs: {
      cell: _objectSpread({}, cellAttributesBySize['xs']),
      headerCell: _objectSpread({}, cellAttributesBySize['xs'])
    },
    s: {
      cell: _objectSpread({}, cellAttributesBySize['s']),
      headerCell: _objectSpread({}, cellAttributesBySize['s'])
    },
    m: {
      cell: _objectSpread({}, cellAttributesBySize['m']),
      headerCell: _objectSpread({}, cellAttributesBySize['m'])
    },
    l: {
      cell: _objectSpread({}, cellAttributesBySize['l']),
      headerCell: _objectSpread({}, cellAttributesBySize['l'])
    },
    xl: {
      cell: _objectSpread({}, cellAttributesBySize['xl']),
      headerCell: _objectSpread({}, cellAttributesBySize['xl'])
    },
    xxl: {
      cell: _objectSpread({}, cellAttributesBySize['xxl']),
      headerCell: _objectSpread({}, cellAttributesBySize['xxl'])
    }
  }
};
//# sourceMappingURL=FormLineItems.theme.js.map